import React from "react";
import classes from "./cursorPosition.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrosshairs } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { Tooltip } from "antd";
import { POINTER_MODES } from "../../../../constants/editor";

const CursorPosition = ({
  cursorLeftPdf,
  cursorTopPdf,
  isActive,
  onChangeMode,
}) => {
  return (
    <div className={classNames(classes.PositionWrap, "text=primary")}>
      <Tooltip title="Position">
        <FontAwesomeIcon
          onClick={() => onChangeMode(POINTER_MODES.POSITION)}
          icon={faCrosshairs}
          className={classNames(classes.Icon, {
            [classes.ActiveIcon]: isActive,
          }, isActive ? "text-primary" : "")}
        />
      </Tooltip>
      <span className={classNames(classes.PositionData, "text-primary")}>
        {!isActive ? "-,-" : cursorLeftPdf + ", " + cursorTopPdf}
      </span>
    </div>
  );
};

export default CursorPosition;
